import { Dialog, DialogActions, DialogTitle, Button } from "@mui/material";
import { useTheme } from "@mui/system";
import React from "react";

const ConfermaElimina = ({ open, setOpen, onConfirm }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "300px", // Set your width here
            backgroundColor:
              // fallback to light if theme is not available
              typeof theme !== "undefined" && theme.palette.mode === "dark"
                ? "#1B2635"
                : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Confermi di voler eliminare la fascia?</DialogTitle>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="primary"
          sx={{ marginRight: "8px" }}
        >
          Chiudi
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ marginRight: "8px" }}
        >
          Elimina
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfermaElimina;
